import React from 'react';
import { CatalogItem, SerializedKitAsset } from '../../../../redux/api/fymAPI.types';
import { useEmailLinkActions } from './assets/useEmailLinkActions';
import { useKitNavigation } from './assets/useKitNavigation';
import { KitZip } from './assets/useKitZip';

interface ReleaseEmailLinksProps {
  item: CatalogItem;
  assets: SerializedKitAsset[];
  zip: KitZip;
}

/**
 * The work email links of the release page (`?zip=1`: Download all, `?post=<uuid>`: Post it). They
 * run on every tab, because a link with no tab opens Overview. Draws nothing.
 */
export const ReleaseEmailLinks: React.FC<ReleaseEmailLinksProps> = ({ item, assets, zip }) => {
  const navigation = useKitNavigation(item);
  useEmailLinkActions({ assets, downloadAll: zip.download, postAsset: navigation.postAsset });
  return null;
};
